import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ScreeningLight } from 'src/app/models/screeningInvite';

@Component({
  selector: 'app-grid-settings-summary',
  templateUrl: './grid-settings-summary.component.html',
  styleUrls: ['./grid-settings-summary.component.less']
})
export class GridSettingsSummaryComponent implements OnInit, AfterViewInit{
  def: NgbNav;
  activeId: number;
  
  @Input() screening: ScreeningLight;

  constructor(public modalService: NgbModal) {
    
  }
  ngOnInit(): void {
    console.log(this.screening);
  }
  ngAfterViewInit(): void {
  }

}
